<template>
  <div class="members">
    <el-tabs v-model="activeTab" @tab-click="onTabChange">
      <!-- 会员列表 -->
      <el-tab-pane label="会员列表" name="list">
        <!-- 统计卡片 -->
        <el-row :gutter="20" class="stats-row">
          <el-col :span="6">
            <el-card shadow="hover" class="stat-card">
              <div class="stat-inner">
                <div class="stat-icon-box blue"><i class="el-icon-user-solid"></i></div>
                <div>
                  <h3>{{ memberStats.total || 0 }}</h3>
                  <p>本域总会员 (人)</p>
                </div>
              </div>
            </el-card>
          </el-col>
          <el-col :span="6">
            <el-card shadow="hover" class="stat-card">
              <div class="stat-inner">
                <div class="stat-icon-box red"><i class="el-icon-user"></i></div>
                <div>
                  <h3>{{ memberStats.active || 0 }}</h3>
                  <p>有效会员 (人)</p>
                </div>
              </div>
            </el-card>
          </el-col>
          <el-col :span="6">
            <el-card shadow="hover" class="stat-card">
              <div class="stat-inner">
                <div class="stat-icon-box orange"><i class="el-icon-medal"></i></div>
                <div>
                  <h3>{{ memberStats.managers || 0 }}</h3>
                  <p>业务经理 (人)</p>
                </div>
              </div>
            </el-card>
          </el-col>
          <el-col :span="6">
            <el-card shadow="hover" class="stat-card">
              <div class="stat-inner">
                <div class="stat-icon-box green"><i class="el-icon-plus"></i></div>
                <div>
                  <h3>{{ memberStats.newMembers || 0 }}</h3>
                  <p>本月新增 (人)</p>
                </div>
              </div>
            </el-card>
          </el-col>
        </el-row>

        <!-- 筛选区 -->
        <el-card shadow="never" class="filter-card">
          <div class="filter-row">
            <div class="filter-item">
              <span class="filter-label">搜索会员:</span>
              <el-input v-model="memberSearch" placeholder="搜索会员昵称/手机号" size="small" style="width:240px" clearable />
            </div>
            <div class="filter-item">
              <span class="filter-label">身份筛选:</span>
              <el-select v-model="memberLevel" placeholder="全部" size="small" style="width:140px" clearable>
                <el-option label="全部" value="" />
                <el-option label="普通粉丝" value="fan" />
                <el-option label="有效会员" value="member" />
                <el-option label="业务经理" value="manager" />
              </el-select>
            </div>
            <div class="filter-actions">
              <el-button type="primary" size="small" @click="searchMembers">搜索</el-button>
              <el-button size="small" @click="resetMemberFilter">重置</el-button>
            </div>
          </div>
        </el-card>

        <!-- 会员表格 -->
        <el-card shadow="never" style="margin-top:16px">
          <el-table :data="memberList" border stripe v-loading="memberLoading">
            <el-table-column prop="id" label="会员ID" width="80" />
            <el-table-column label="头像" width="70">
              <template slot-scope="scope">
                <el-avatar :size="36" :src="scope.row.avatar" icon="el-icon-user-solid" />
              </template>
            </el-table-column>
            <el-table-column prop="nickname" label="昵称" width="120" />
            <el-table-column prop="phone" label="手机号" width="130" />
            <el-table-column label="会员身份" width="100">
              <template slot-scope="scope">
                <el-tag :type="scope.row.level === 'manager' ? 'danger' : scope.row.level === 'member' ? 'success' : 'info'" size="small">
                  {{ levelText(scope.row.level) }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="invite_count" label="推荐人数" width="90" />
            <el-table-column label="累计消费额" width="120">
              <template slot-scope="scope">&yen; {{ scope.row.total_spent || 0 }}</template>
            </el-table-column>
            <el-table-column prop="create_time" label="注册时间" width="150" />
            <el-table-column prop="last_active" label="最后活跃" width="150" />
            <el-table-column label="操作" width="240" fixed="right">
              <template slot-scope="scope">
                <el-button type="text" size="mini" @click="openMemberDetail(scope.row)">详情</el-button>
                <el-button type="text" size="mini" @click="openMemberOrders(scope.row)">订单</el-button>
                <el-button type="text" size="mini" @click="openMemberLogs(scope.row)">流水</el-button>
                <el-button type="text" size="mini" @click="openSetLevel(scope.row)">设级别</el-button>
              </template>
            </el-table-column>
          </el-table>
          <div class="pagination-box">
            <el-pagination background layout="total, prev, pager, next" :total="memberTotal" :page-size="10" :current-page="memberPage" @current-change="onMemberPageChange" />
          </div>
        </el-card>
      </el-tab-pane>

      <!-- 个人业绩 -->
      <el-tab-pane label="个人业绩" name="personal">
        <el-card shadow="never" class="filter-card">
          <div class="filter-row">
            <div class="filter-item">
              <span class="filter-label">时间范围:</span>
              <el-date-picker v-model="personalDateRange" type="daterange" range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期" size="small" value-format="yyyy-MM-dd" />
            </div>
            <div class="filter-item">
              <span class="filter-label">会员选择:</span>
              <el-select v-model="personalMember" placeholder="全部会员" size="small" style="width:160px" clearable filterable>
                <el-option v-for="m in memberOptions" :key="m.id" :label="m.nickname" :value="m.id" />
              </el-select>
            </div>
            <el-radio-group v-model="personalDimension" size="small">
              <el-radio-button label="day">日</el-radio-button>
              <el-radio-button label="week">周</el-radio-button>
              <el-radio-button label="month">月</el-radio-button>
            </el-radio-group>
          </div>
        </el-card>

        <el-row :gutter="20" class="stats-row">
          <el-col :span="6">
            <el-card shadow="hover" class="perf-stat"><p>今日新增业绩</p><h3>&yen; {{ personalStats.today || '0.00' }}</h3></el-card>
          </el-col>
          <el-col :span="6">
            <el-card shadow="hover" class="perf-stat"><p>本周新增业绩</p><h3>&yen; {{ personalStats.week || '0.00' }}</h3></el-card>
          </el-col>
          <el-col :span="6">
            <el-card shadow="hover" class="perf-stat"><p>本月新增业绩</p><h3>&yen; {{ personalStats.month || '0.00' }}</h3></el-card>
          </el-col>
          <el-col :span="6">
            <el-card shadow="hover" class="perf-stat"><p>历史总业绩</p><h3>&yen; {{ personalStats.total || '0.00' }}</h3></el-card>
          </el-col>
        </el-row>

        <el-card shadow="never">
          <div slot="header">个人业绩趋势</div>
          <div ref="personalChart" class="chart-box"></div>
        </el-card>

        <el-card shadow="never" style="margin-top:16px">
          <div slot="header">个人业绩明细</div>
          <el-table :data="personalList" border stripe>
            <el-table-column prop="date" label="日期" width="120" />
            <el-table-column prop="nickname" label="会员名" width="100" />
            <el-table-column prop="phone" label="手机号" width="130" />
            <el-table-column label="身份" width="100">
              <template slot-scope="scope">{{ levelText(scope.row.level) }}</template>
            </el-table-column>
            <el-table-column label="新增业绩" width="120">
              <template slot-scope="scope">&yen; {{ scope.row.new_amount || 0 }}</template>
            </el-table-column>
            <el-table-column label="累计业绩" width="120">
              <template slot-scope="scope">&yen; {{ scope.row.total_amount || 0 }}</template>
            </el-table-column>
            <el-table-column prop="remark" label="备注" min-width="140" show-overflow-tooltip />
          </el-table>
        </el-card>
      </el-tab-pane>

      <!-- 团队业绩 -->
      <el-tab-pane label="团队业绩" name="team">
        <el-alert
          v-if="teamGenerations"
          type="info"
          :closable="false"
          show-icon
          class="generations-alert"
          :title="'团队业绩统计范围：向下 ' + teamGenerations + ' 代（由系统配置 team_performance_generations 控制）'"
        />
        <el-card shadow="never" class="filter-card">
          <div class="filter-row">
            <div class="filter-item">
              <span class="filter-label">时间范围:</span>
              <el-date-picker v-model="teamDateRange" type="daterange" range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期" size="small" value-format="yyyy-MM-dd" />
            </div>
            <div class="filter-item">
              <span class="filter-label">团队负责人:</span>
              <el-select v-model="teamLeader" placeholder="全部团队" size="small" style="width:160px" clearable>
                <el-option v-for="m in managerOptions" :key="m.id" :label="m.nickname" :value="m.id" />
              </el-select>
            </div>
            <el-radio-group v-model="teamDimension" size="small">
              <el-radio-button label="day">日</el-radio-button>
              <el-radio-button label="week">周</el-radio-button>
              <el-radio-button label="month">月</el-radio-button>
            </el-radio-group>
          </div>
        </el-card>

        <el-row :gutter="20" class="stats-row">
          <el-col :span="6"><el-card shadow="hover" class="perf-stat"><p>今日团队总业绩</p><h3 class="red-text">&yen; {{ teamStats.today || '0.00' }}</h3></el-card></el-col>
          <el-col :span="6"><el-card shadow="hover" class="perf-stat"><p>本周团队总业绩</p><h3>&yen; {{ teamStats.week || '0.00' }}</h3></el-card></el-col>
          <el-col :span="6"><el-card shadow="hover" class="perf-stat"><p>本月团队总业绩</p><h3>&yen; {{ teamStats.month || '0.00' }}</h3></el-card></el-col>
          <el-col :span="6"><el-card shadow="hover" class="perf-stat"><p>团队累计总业绩</p><h3>&yen; {{ teamStats.total || '0.00' }}</h3></el-card></el-col>
        </el-row>

        <el-card shadow="never">
          <div slot="header">团队业绩排行榜</div>
          <el-table :data="teamRanking" border stripe>
            <el-table-column label="排名" width="80"><template slot-scope="scope">{{ scope.$index + 1 }}</template></el-table-column>
            <el-table-column prop="team_name" label="团队名" width="120" />
            <el-table-column prop="leader_name" label="负责人" width="100" />
            <el-table-column prop="member_count" label="团队人数" width="90" />
            <el-table-column label="今日业绩" width="120"><template slot-scope="scope">&yen; {{ scope.row.today || 0 }}</template></el-table-column>
            <el-table-column label="本周业绩" width="120"><template slot-scope="scope">&yen; {{ scope.row.week || 0 }}</template></el-table-column>
            <el-table-column label="本月业绩" width="120"><template slot-scope="scope">&yen; {{ scope.row.month || 0 }}</template></el-table-column>
            <el-table-column label="总业绩" width="120"><template slot-scope="scope">&yen; {{ scope.row.total || 0 }}</template></el-table-column>
          </el-table>
        </el-card>

        <el-card shadow="never" style="margin-top:16px">
          <div slot="header">团队业绩明细</div>
          <el-table :data="teamDetail" border stripe>
            <el-table-column prop="date" label="日期" width="120" />
            <el-table-column prop="team_name" label="团队名" width="120" />
            <el-table-column prop="leader_name" label="负责人" width="100" />
            <el-table-column prop="member_count" label="团队人数" width="90" />
            <el-table-column label="新增业绩" width="120"><template slot-scope="scope">&yen; {{ scope.row.new_amount || 0 }}</template></el-table-column>
            <el-table-column label="累计业绩" width="120"><template slot-scope="scope">&yen; {{ scope.row.total_amount || 0 }}</template></el-table-column>
            <el-table-column label="人均产值" width="120"><template slot-scope="scope">&yen; {{ scope.row.avg_amount || 0 }}</template></el-table-column>
          </el-table>
        </el-card>
      </el-tab-pane>

      <!-- 数据汇总 -->
      <el-tab-pane label="数据汇总" name="summary">
        <el-card shadow="never" class="filter-card">
          <div class="filter-row">
            <div class="filter-item">
              <span class="filter-label">年份选择:</span>
              <el-select v-model="summaryYear" size="small" style="width:120px">
                <el-option label="2024年" :value="2024" />
                <el-option label="2025年" :value="2025" />
                <el-option label="2026年" :value="2026" />
              </el-select>
            </div>
            <div class="filter-item">
              <span class="filter-label">月份/季度:</span>
              <el-select v-model="summaryPeriod" size="small" style="width:140px">
                <el-option label="全年" value="all" />
                <el-option label="第一季度" value="Q1" />
                <el-option label="第二季度" value="Q2" />
                <el-option label="第三季度" value="Q3" />
                <el-option label="第四季度" value="Q4" />
                <el-option v-for="m in 12" :key="m" :label="m + '月'" :value="m" />
              </el-select>
            </div>
          </div>
        </el-card>

        <el-row :gutter="20" class="stats-row">
          <el-col :span="8" v-for="item in summaryCards" :key="item.label">
            <el-card shadow="hover" class="summary-card">
              <p class="summary-label"><i :class="item.icon"></i> {{ item.label }}</p>
              <h3 class="summary-value">{{ item.value }}</h3>
              <p class="summary-desc">{{ item.desc }}</p>
            </el-card>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-card shadow="never"><div slot="header">月度业绩走势</div><div ref="summaryMonthlyChart" class="chart-box"></div></el-card>
          </el-col>
          <el-col :span="12">
            <el-card shadow="never"><div slot="header">会员结构分布</div><div ref="summaryPieChart" class="chart-box"></div></el-card>
          </el-col>
        </el-row>

        <el-card shadow="never" style="margin-top:16px">
          <div slot="header">月度数据汇总</div>
          <el-table :data="summaryTable" border stripe>
            <el-table-column prop="month" label="月份" width="100" />
            <el-table-column prop="new_members" label="新增会员" width="100" />
            <el-table-column label="新增业绩" width="120"><template slot-scope="scope">&yen; {{ scope.row.new_amount || 0 }}</template></el-table-column>
            <el-table-column label="总业绩" width="120"><template slot-scope="scope">&yen; {{ scope.row.total_amount || 0 }}</template></el-table-column>
            <el-table-column prop="active_members" label="活跃会员" width="100" />
            <el-table-column prop="remark" label="备注" min-width="140" show-overflow-tooltip />
          </el-table>
        </el-card>
      </el-tab-pane>
    </el-tabs>

    <!-- 会员详情弹窗 -->
    <el-dialog title="会员详细信息" :visible.sync="memberDetailVisible" width="600px">
      <div v-if="detailMember" class="member-detail">
        <div class="detail-header">
          <el-avatar :size="64" :src="detailMember.avatar" icon="el-icon-user-solid" />
          <div class="detail-info">
            <h3>{{ detailMember.nickname }}</h3>
            <p>{{ detailMember.phone }} | {{ levelText(detailMember.level) }}</p>
          </div>
        </div>
        <el-descriptions :column="2" border style="margin-top:20px">
          <el-descriptions-item label="会员ID">{{ detailMember.id }}</el-descriptions-item>
          <el-descriptions-item label="注册时间">{{ detailMember.create_time }}</el-descriptions-item>
          <el-descriptions-item label="累计消费">&yen; {{ detailMember.total_spent || 0 }}</el-descriptions-item>
          <el-descriptions-item label="推荐人数">{{ detailMember.invite_count || 0 }} 人</el-descriptions-item>
          <el-descriptions-item label="最后活跃">{{ detailMember.last_active }}</el-descriptions-item>
        </el-descriptions>
      </div>
      <div slot="footer"><el-button @click="memberDetailVisible = false">关闭</el-button></div>
    </el-dialog>

    <!-- 会员订单弹窗 -->
    <el-dialog title="会员消费订单" :visible.sync="memberOrderVisible" width="800px">
      <el-table :data="memberOrders" border stripe>
        <el-table-column prop="order_no" label="订单号" width="160" />
        <el-table-column prop="goods_name" label="商品名" min-width="160" show-overflow-tooltip />
        <el-table-column label="金额" width="100"><template slot-scope="scope">&yen; {{ scope.row.total_amount }}</template></el-table-column>
        <el-table-column prop="create_time" label="下单时间" width="150" />
        <el-table-column label="状态" width="80">
          <template slot-scope="scope">{{ ['待付款','待发货','待收货','已完成','已取消'][scope.row.status] || '-' }}</template>
        </el-table-column>
      </el-table>
      <div slot="footer"><el-button @click="memberOrderVisible = false">关闭</el-button></div>
    </el-dialog>

    <!-- 会员级别设置弹窗 -->
    <el-dialog title="会员级别设置" :visible.sync="setLevelVisible" width="480px">
      <div v-if="levelTargetMember" class="set-level-body">
        <div class="level-member-info">
          <el-avatar :size="48" :src="levelTargetMember.avatar" icon="el-icon-user-solid" />
          <div>
            <h3>{{ levelTargetMember.nickname }}</h3>
            <p>{{ levelTargetMember.phone }} | 当前级别：{{ levelText(levelTargetMember.level) }}</p>
          </div>
        </div>

        <el-form label-width="100px" class="level-form">
          <el-form-item label="设置为">
            <el-radio-group v-model="setLevelForm.level">
              <el-radio label="fan">普通粉丝</el-radio>
              <el-radio label="member">有效会员</el-radio>
              <el-radio label="manager">业务经理</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-form>

        <el-alert
          v-if="setLevelForm.level === 'manager'"
          type="warning"
          :closable="false"
          show-icon
          title="设置为业务经理后，该会员将不再享受会员升级后的第二单邀请100%奖励（佣金按常规比例30%计算），此标记永久生效。"
        />
      </div>
      <div slot="footer">
        <el-button @click="setLevelVisible = false">取消</el-button>
        <el-button type="primary" :loading="setLevelLoading" @click="confirmSetLevel">确定</el-button>
      </div>
    </el-dialog>

    <!-- 会员资金流水弹窗 -->
    <el-dialog :title="'会员资金流水 - ' + (logTargetMember ? logTargetMember.nickname : '')" :visible.sync="memberLogVisible" width="860px">
      <el-table :data="memberLogList" border stripe v-loading="memberLogLoading" size="small">
        <el-table-column label="流水类型" width="150">
          <template slot-scope="scope">
            <el-tag size="small">{{ scope.row.log_type_text }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="资金池" width="90">
          <template slot-scope="scope">{{ scope.row.fund_type_text }}</template>
        </el-table-column>
        <el-table-column label="变动金额" width="130">
          <template slot-scope="scope">
            <span :class="Number(scope.row.amount) >= 0 ? 'amount-in' : 'amount-out'">
              {{ Number(scope.row.amount) >= 0 ? '+' : '' }}{{ scope.row.amount }}
            </span>
          </template>
        </el-table-column>
        <el-table-column label="变动前余额" width="120">
          <template slot-scope="scope">{{ scope.row.balance_before }}</template>
        </el-table-column>
        <el-table-column label="变动后余额" width="120">
          <template slot-scope="scope">{{ scope.row.balance_after }}</template>
        </el-table-column>
        <el-table-column prop="order_no" label="关联订单" width="150" show-overflow-tooltip />
        <el-table-column prop="remark" label="备注" min-width="140" show-overflow-tooltip />
        <el-table-column prop="create_time" label="时间" width="160" />
      </el-table>
      <div v-if="memberLogTotal === 0" style="text-align:center;color:#909399;padding:20px;">该会员暂无资金流水记录</div>
      <div slot="footer">
        <el-pagination
          style="display:inline-block;"
          background
          layout="prev, pager, next"
          :total="memberLogTotal"
          :page-size="20"
          :current-page.sync="memberLogPage"
          @current-change="fetchMemberLogs"
        />
        <el-button type="primary" @click="memberLogVisible = false">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import * as echarts from 'echarts'
import { getMembers, getMembersStats, getMembersPerformance, getMembersSummary, getMemberOrders, getMemberLogs, setMemberLevel } from '@/api'

export default {
  name: 'Members',
  data() {
    return {
      activeTab: 'list',
      // 会员列表
      memberSearch: '', memberLevel: '',
      memberList: [], memberLoading: false, memberTotal: 0, memberPage: 1,
      memberStats: { total: 0, active: 0, managers: 0, newMembers: 0 },
      memberOptions: [],
      managerOptions: [],
      memberDetailVisible: false, detailMember: null,
      memberOrderVisible: false, memberOrders: [],
      // 会员级别设置
      setLevelVisible: false, setLevelLoading: false, levelTargetMember: null,
      setLevelForm: { level: 'fan' },
      // 会员资金流水
      memberLogVisible: false, memberLogLoading: false, memberLogList: [],
      memberLogTotal: 0, memberLogPage: 1, logTargetMember: null,
      // 个人业绩
      personalDateRange: [], personalMember: '', personalDimension: 'month',
      personalStats: {}, personalList: [],
      // 团队业绩
      teamDateRange: [], teamLeader: '', teamDimension: 'month',
      teamStats: {}, teamRanking: [], teamDetail: [], teamGenerations: 0,
      // 数据汇总
      summaryYear: 2026, summaryPeriod: 'all',
      summaryCards: [],
      summaryTable: []
    }
  },
  mounted() {
    this.loadMemberStats()
    this.loadMembers()
  },
  methods: {
    onTabChange(tab) {
      if (tab.name === 'personal' || tab.name === 'team') this.loadPerformance(tab.name)
      if (tab.name === 'summary') this.loadSummary()
    },
    levelText(level) {
      const map = { fan: '普通粉丝', member: '有效会员', manager: '业务经理' }
      return map[level] || level || '-'
    },
    // 会员列表
    async loadMemberStats() {
      try {
        const res = await getMembersStats()
        this.memberStats = res || {}
      } catch (e) {}
    },
    async loadMembers() {
      this.memberLoading = true
      try {
        const res = await getMembers({ page: this.memberPage, limit: 10, title: this.memberSearch, level: this.memberLevel })
        this.memberList = res.data || res || []
        this.memberTotal = res.total || 0
        if (!this.memberOptions.length && this.memberList.length) {
          this.memberOptions = this.memberList.map(m => ({ id: m.id, nickname: m.nickname }))
          this.managerOptions = this.memberList.filter(m => m.level === 'manager').map(m => ({ id: m.id, nickname: m.nickname }))
        }
      } catch (e) {}
      this.memberLoading = false
    },
    searchMembers() { this.memberPage = 1; this.loadMembers(); },
    resetMemberFilter() { this.memberSearch = ''; this.memberLevel = ''; this.searchMembers(); },
    onMemberPageChange(p) { this.memberPage = p; this.loadMembers(); },
    openMemberDetail(row) { this.detailMember = row; this.memberDetailVisible = true; },
    async openMemberOrders(row) {
      try {
        this.memberOrders = []
        const res = await getMemberOrders(row.id)
        this.memberOrders = res || []
      } catch (e) {
        this.memberOrders = []
      }
      this.memberOrderVisible = true
    },
    // 会员资金流水
    openMemberLogs(row) {
      this.logTargetMember = row
      this.memberLogList = []
      this.memberLogTotal = 0
      this.memberLogPage = 1
      this.memberLogVisible = true
      this.fetchMemberLogs()
    },
    fetchMemberLogs() {
      if (!this.logTargetMember) return
      this.memberLogLoading = true
      getMemberLogs(this.logTargetMember.id, { page: this.memberLogPage, limit: 20 }).then(res => {
        this.memberLogList = res.list || []
        this.memberLogTotal = res.total || 0
      }).catch(() => {
        this.memberLogList = []
        this.memberLogTotal = 0
        this.$message.error('获取会员流水失败')
      }).finally(() => {
        this.memberLogLoading = false
      })
    },
    // 会员级别设置
    openSetLevel(row) {
      this.levelTargetMember = row
      this.setLevelForm.level = row.level || 'fan'
      this.setLevelVisible = true
    },
    confirmSetLevel() {
      if (!this.levelTargetMember) return
      this.$confirm(`确认将会员「${this.levelTargetMember.nickname}」级别设置为「${this.levelText(this.setLevelForm.level)}」？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.setLevelLoading = true
        setMemberLevel({
          member_id: this.levelTargetMember.id,
          level: this.setLevelForm.level
        }).then(() => {
          this.$message.success('会员级别设置成功')
          this.setLevelVisible = false
          this.loadMembers()
        }).catch(() => {
          // 错误已在拦截器提示
        }).finally(() => {
          this.setLevelLoading = false
        })
      }).catch(() => {})
    },
    // 个人/团队业绩
    async loadPerformance(type) {
      try {
        const res = await getMembersPerformance({ type, member_id: this.personalMember, leader_id: this.teamLeader, dimension: type === 'personal' ? this.personalDimension : this.teamDimension })
        if (type === 'personal') {
          this.personalStats = res.stats || {}
          this.personalList = res.list || []
          this.$nextTick(() => this.initPersonalChart())
        } else {
          this.teamStats = res.stats || {}
          this.teamRanking = res.ranking || []
          this.teamDetail = res.list || []
          this.teamGenerations = res.generations || 0
        }
      } catch (e) {}
    },
    initPersonalChart() {
      const dom = this.$refs.personalChart
      if (!dom) return
      const chart = echarts.init(dom)
      chart.setOption({
        tooltip: { trigger: 'axis' },
        xAxis: { type: 'category', data: (this.personalList || []).map(d => d.date) || [] },
        yAxis: { type: 'value' },
        series: [{ data: (this.personalList || []).map(d => d.new_amount || 0), type: 'line', smooth: true, lineStyle: { color: '#3a8ee6' }, itemStyle: { color: '#3a8ee6' } }]
      })
    },
    // 数据汇总
    async loadSummary() {
      try {
        const res = await getMembersSummary()
        this.summaryCards = [
          { label: '会员活跃度', icon: 'el-icon-data-line', value: (res.active_rate || 0) + '%', desc: '本月活跃 ' + (res.active_count || 0) + ' 人' },
          { label: '会员转化率', icon: 'el-icon-refresh', value: (res.conversion_rate || 0) + '%', desc: '本月新增有效会员 ' + (res.new_members || 0) + ' 人' },
          { label: '业绩达标率', icon: 'el-icon-aim', value: (res.target_rate || 0) + '%', desc: '达标会员 ' + (res.target_count || 0) + ' 人' },
          { label: '人均产值', icon: 'el-icon-money', value: '&yen; ' + (res.avg_amount || 0), desc: '总业绩 / 总会员' },
          { label: '高价值会员占比', icon: 'el-icon-star-on', value: (res.vip_rate || 0) + '%', desc: '消费 > 1万元会员 ' + (res.vip_count || 0) + ' 人' },
          { label: '业绩增长率', icon: 'el-icon-top', value: '+' + (res.growth_rate || 0) + '%', desc: '环比上月业绩增长' }
        ]
        this.summaryTable = res.monthly || []
        this.$nextTick(() => {
          this.initSummaryCharts(res)
        })
      } catch (e) {}
    },
    initSummaryCharts(res) {
      const monthlyDom = this.$refs.summaryMonthlyChart
      const pieDom = this.$refs.summaryPieChart
      if (monthlyDom) {
        const chart = echarts.init(monthlyDom)
        chart.setOption({
          tooltip: { trigger: 'axis' },
          xAxis: { type: 'category', data: (res.monthly || []).map(d => d.month) },
          yAxis: { type: 'value' },
          series: [{ data: (res.monthly || []).map(d => d.total_amount || 0), type: 'bar', color: '#3a8ee6' }]
        })
      }
      if (pieDom && res.structure) {
        const chart = echarts.init(pieDom)
        chart.setOption({
          tooltip: { trigger: 'item' },
          series: [{
            type: 'pie', radius: ['40%', '70%'],
            data: [
              { value: res.structure.fan || 0, name: '普通粉丝' },
              { value: res.structure.member || 0, name: '有效会员' },
              { value: res.structure.manager || 0, name: '业务经理' }
            ]
          }]
        })
      }
    }
  }
}
</script>

<style scoped>
.stats-row { margin-bottom: 20px; }
.stat-card .stat-inner { display: flex; align-items: center; gap: 16px; }
.stat-inner h3 { font-size: 24px; font-weight: bold; margin: 0; color: #303133; }
.stat-inner p { font-size: 12px; color: #909399; margin: 4px 0 0; }
.stat-icon-box { width: 44px; height: 44px; border-radius: 50%; display: flex; align-items: center; justify-content: center; font-size: 20px; color: #fff; }
.stat-icon-box.blue { background: #409eff; }
.stat-icon-box.red { background: #3a8ee6; }
.stat-icon-box.orange { background: #e6a23c; }
.stat-icon-box.green { background: #67c23a; }
.filter-card { margin-bottom: 0; }
.generations-alert { margin-bottom: 16px; }
.filter-row { display: flex; align-items: center; gap: 16px; flex-wrap: wrap; }
.filter-item { display: flex; align-items: center; gap: 8px; }
.filter-label { font-size: 13px; color: #606266; white-space: nowrap; }
.filter-actions { margin-left: auto; display: flex; gap: 8px; }
.pagination-box { text-align: right; margin-top: 16px; }
.perf-stat { text-align: center; }
.perf-stat p { font-size: 12px; color: #909399; margin: 0 0 8px; }
.perf-stat h3 { font-size: 24px; font-weight: bold; margin: 0; color: #303133; }
.perf-stat h3.red-text { color: #3a8ee6; }
.chart-box { height: 300px; }
.summary-card { text-align: center; padding: 8px; }
.summary-label { font-size: 13px; color: #606266; margin: 0 0 8px; }
.summary-value { font-size: 22px; font-weight: bold; color: #303133; margin: 0 0 4px; }
.summary-desc { font-size: 11px; color: #c0c4cc; margin: 0; }
.member-detail .detail-header { display: flex; align-items: center; gap: 16px; }
.detail-info h3 { margin: 0; font-size: 18px; }
.detail-info p { margin: 4px 0 0; color: #909399; font-size: 13px; }
.set-level-body .level-member-info { display: flex; align-items: center; gap: 16px; margin-bottom: 20px; }
.set-level-body .level-member-info h3 { margin: 0; font-size: 16px; }
.set-level-body .level-member-info p { margin: 4px 0 0; color: #909399; font-size: 13px; }
.level-form { margin-top: 10px; }
.amount-in { color: #67c23a; font-weight: bold; }
.amount-out { color: #f56c6c; font-weight: bold; }
</style>
